import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { getUserWallet, loadUser, loadUserReferralIdentifier, modifyUser, loadUserStoreCreditEvents, loadUserAddressBook, modifyUserAddressBook, removeFromUserAddressBook } from '../redux/actions';
/**
 * The `useUser` hook returns the current user and functions for loading data
 * about the user. At the moment, the only user information Chord supports is
 * the user's referral identifier and personalized referral url.
 *
 * @example
 *
 * ```javascript
 * import { useUser } from '@chordcommerce/react-autonomy'
 *
 * const AccountPage = () => {
 *   const { user, loadUser } = useUser()
 *
 *   return <h1>Hello {user.name}</h1>
 * }
 * ```
 *
 * @category Hook
 */
export function useUser() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user, shallowEqual);
  const actionDispatches = useMemo(() => bindActionCreators({
    getUserWallet,
    loadUser,
    loadUserReferralIdentifier,
    modifyUser,
    loadUserStoreCreditEvents,
    loadUserAddressBook,
    modifyUserAddressBook,
    removeFromUserAddressBook
  }, dispatch), [dispatch]);
  return {
    user,
    ...actionDispatches
  };
}